import "./Career.css";
import LocationDot from "../images/icons/location-dot.svg";
import LongArrowRight from "../images/icons/long-arrow-right.svg";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { usePreloader } from "../contexts/PreloaderContext";

gsap.registerPlugin(ScrollTrigger);

export function Career({
  title,
  location,
  description,
  uri = `mailto:jobs@serova.bio?subject=Application for ${title}`,
}: {
  title: string;
  location: string;
  description: string;
  uri?: string;
}) {
  const careerRef = useRef<HTMLAnchorElement>(null);
  const { isComplete } = usePreloader();

  useEffect(() => {
    if (careerRef.current && isComplete) {
      gsap.fromTo(
        careerRef.current,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: careerRef.current,
            start: "top 85%",
            toggleActions: "play none none none",
          },
        },
      );
    }
  }, [isComplete]);

  return (
    <a
      href={uri}
      className="career"
      target="_blank"
      rel="noopener noreferrer"
      ref={careerRef}
    >
      <div className="career__info">
        <h3 className="career__title">{title}</h3>
        <p className="career__location">
          <img
            src={LocationDot}
            alt="Location dot icon"
            className="career__icon career__location-icon"
          />
          {location}
        </p>
        <p className="career__description">{description}</p>
      </div>
      <div className="career__apply-button">
        Apply now
        <img
          src={LongArrowRight}
          alt="Long arrow right icon"
          className="career__icon career__apply-button-icon"
        />
      </div>
    </a>
  );
}
